// A NUXT_PUBLIC_* override arrives as a string, so an env that opts in reads
// `'true'` while the config default is a real boolean. Accept both, else off.
export function isEnvFlagEnabled(value: unknown): boolean {
  return value === true || value === 'true'
}
